export default [
    {
        name: '<code>$dropdown-mobile-breakpoint</code>',
        description: 'The dropdown will be displayed as a modal below this value.',
        default: '<code>$desktop</code>'
    },
    {
        name: '<code>$dropdown-background-color</code>',
        description: 'Modal background color when the dropdown is shown as a modal.',
        default: '<code>rgba($black, 0.86)</code>'
    },
    {
        name: '<code>$dropdown-disabled-opacity:</code>',
        description: 'Defines dropdown disabled opacity.',
        default: '<code>0.5</code>'
    },
]



// WEBPACK FOOTER //
// ./docs/pages/components/dropdown/variables/dropdown.js